import date from 'date-and-time';

/**
 * The days of a Social period: the daily read writes the day before, so the period ends yesterday
 * (UTC) and holds `days` days. YYYY-MM-DD.
 */
export function socialPeriodRange(days: number, now: Date = new Date()): { from: string; to: string } {
  const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  const end = date.addDays(today, -1, true);
  const start = date.addDays(end, -(Math.max(1, days) - 1), true);
  return { from: date.format(start, 'YYYY-MM-DD', true), to: date.format(end, 'YYYY-MM-DD', true) };
}
